import type { ScreeningQuestion } from '@/hooks/useMultiplePricesStore';
import { isRichTextHtmlEmpty } from '@/utils/isRichTextHtmlEmpty';

export const isScreeningAnswerDisqualified = (question: ScreeningQuestion) =>
  question.answerType === 'single_choice' &&
  question.autoDisqualify === true &&
  !!question.answer &&
  !!question.disqualifyingOptions?.includes(question.answer);

export const isScreeningAnswerValid = (question: ScreeningQuestion) => {
  if (question.answerType === 'single_choice') {
    return (
      !!question.answer?.trim() &&
      !!question.options?.includes(question.answer) &&
      !isScreeningAnswerDisqualified(question)
    );
  }
  return !isRichTextHtmlEmpty(question.answer);
};

export const areScreeningQuestionsValid = (questions: ScreeningQuestion[]) =>
  questions.every(isScreeningAnswerValid);
